import { render, staticRenderFns } from "./HubCard.vue?vue&type=template&id=714f5e6d&scoped=true&"
import script from "./HubCard.vue?vue&type=script&lang=ts&"
export * from "./HubCard.vue?vue&type=script&lang=ts&"
import style0 from "./HubCard.vue?vue&type=style&index=0&id=714f5e6d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714f5e6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
